<template>
    <div>

        <b-row>

            <b-col md="2">

                <i @click="toggleViz" class="fa fa-arrow-left" style="font-size: 19px;">&nbsp; ApiCall</i>

            </b-col>

            <b-col>

                <div v-if="!collapsed && !toAdd">

                    <b-row>

                        <b-card title="Basics" class="bg-dark" style="width:100%; margin-top: 9px;">

                            <b-row class="bg-dark">

                                <b-col>

                                    <b-form>

                                        <b-form-group id="input-group-5" label="Endpoint:" label-for="input-5"
                                            description="Endpoint to get data from">
                                            <b-form-input v-model="actionData.endpoint" placeholder="Endpoint"
                                                @change="dataChangedEvent()"></b-form-input>
                                        </b-form-group>

                                        <b-form-group id="input-group-5" label="Slot:" label-for="input-5"
                                            description="Slot to save the result to">
                                            <b-form-select id="input-5" v-model="actionData.slot" value-field="name"
                                                text-field="name" :options="nonDefaultSlots" required
                                                @change="dataChangedEvent()"></b-form-select>
                                        </b-form-group>

                                        <b-form-group id="input-group-5c" label="Result Key:" label-for="input-5c"
                                            description="key to extract from the result">
                                            <b-form-input id="input-5c" v-model="actionData.result_key"
                                                @change="dataChangedEvent()" required></b-form-input>
                                        </b-form-group>

                                        <b-form-group id="input-group-5d" label="Request Type:" label-for="input-5d"
                                            description="Request Type">
                                            <b-form-select id="input-5d" v-model="actionData.request_type"
                                                value-field="value" text-field="text" :options="requestTypes"
                                                @change="dataChangedEvent()" required></b-form-select>
                                        </b-form-group>
 
                                    </b-form>

                                </b-col>

                            </b-row>


                        </b-card>

                    </b-row>

                    <b-row>

                        <b-card title="Interactivity" class="bg-dark" style="width:100%; margin-top: 9px;">

                           

                            <b-row class="bg-dark">

                                <b-col>

                                    <b-form>

                                        <b-form-group id="input-group-6" label="Display Message:" label-for="input-6"
                                            description="Message to display after this action">
                                            <b-form-input id="input-6" v-model="actionData.display_message
                                                " required @change="dataChangedEvent()"></b-form-input>
                                        </b-form-group>

                                        <b-form-group id="input-group-7" label="Error Message:" label-for="input-7"
                                            description="Message to display after this action fails">
                                            <b-form-input id="input-7" v-model="actionData.error_msg" required
                                                @change="dataChangedEvent()"></b-form-input>
                                        </b-form-group>

                                       

                                    </b-form>

                                </b-col>

                            </b-row>


                        </b-card>

                    </b-row>


                    <b-row>

                        <b-card title="Headers" class="bg-dark" style="width:100%; margin-top: 9px;">

                            <p v-if="!headerKeys.length > 0">
                                No headers have been added yet, click
                                the add button to create a header for
                                this action
                            </p>

                            <ul>
                                <li v-for="(key) in headerKeys" :key="key">

                                    <b-row>

                                        <b-col class="bg-dark" style="height: 43px">
                                            <span>
                                                Header:
                                                <b>{{ key }}</b>
                                            </span>
                                        </b-col>

                                        <b-col class="bg-dark" style="height: 43px">
                                            <span>
                                                <b>
                                                    Slot:
                                                    {{ headersData[key] }}</b>
                                            </span>
                                        </b-col>

                                        <b-col>
                                            <b-button @click="
                                                deleteHeader(
                                                    key
                                                )
                                                ">Delete</b-button>
                                        </b-col>

                                    </b-row>
                                </li>
                            </ul>

                            <b-card-footer class="bg-dark">
                                <b-button @click="initAddHeader" variant="primary">Add Header</b-button></b-card-footer>
                        </b-card>

                    </b-row>


                    <b-row>

                        <b-card title="Parameters" class="bg-dark" style="width:100%; margin-top: 9px;">

                            <p v-if="!paramKeys.length > 0">
                                No Parameters have been added yet, click
                                the add button to create a parameter for
                                this action
                            </p>

                            <ul>
                                <li v-for="(key) in paramKeys" :key="key">

                                    <b-row>

                                        <b-col class="bg-dark" style="height: 43px">
                                            <span>
                                                Header:
                                                <b>{{ key }}</b>
                                            </span>
                                        </b-col>

                                        <b-col class="bg-dark" style="height: 43px">
                                            <span>
                                                <b>
                                                    Slot:
                                                    {{ paramsData[key] }}</b>
                                            </span>
                                        </b-col>

                                        <b-col>
                                            <b-button @click="
                                                deleteParam(
                                                    key
                                                )
                                                ">Delete</b-button>
                                        </b-col>

                                    </b-row>
                                </li>
                            </ul>

                            <b-card-footer class="bg-dark">
                                <b-button @click="initAddParam" variant="primary">Add Parameter</b-button></b-card-footer>
                        </b-card>

                    </b-row>


                    <b-row>

                        <b-card title="Constants" class="bg-dark" style="width:100%; margin-top: 9px;">

                            <p v-if="!constKeys.length > 0">
                                No constants have been added yet, click
                                the add button to create a constant for
                                this action.
                            </p>

                            
                            <ul>

                                <li v-for="(key) in constKeys" :key="key">

                                    <b-row>

                                        <b-col class="bg-dark" style="height: 43px">
                                            <span>
                                                Constant:
                                                <b>{{ key }}</b>
                                            </span>
                                        </b-col>

                                        <b-col class="bg-dark" style="height: 43px">
                                            <span>
                                                <b>
                                                    Value:
                                                    {{ constantsData[key] }}</b>
                                            </span>
                                        </b-col>

                                        <b-col>
                                            <b-button @click="
                                                deleteConstant(
                                                    key
                                                )
                                                ">Delete</b-button>
                                        </b-col>

                                    </b-row>
                                </li>
                                
                            </ul>
                            <b-card-footer class="bg-dark">
                                <b-button @click="initAddConstant" variant="primary">Add Constant</b-button></b-card-footer>
                        </b-card>

                    </b-row>





                    <b-row>

                        <b-card title="Conditions" class="bg-dark" style="width:100%; margin-top: 9px;">

                            <p v-if="!conditionsData.length > 0">
                                No conditions have been added yet, click
                                the add button to create a condition for
                                this action
                            </p>

                            <ul>
                                <li v-for="(condition, idx) in conditionsData" :key="idx">

                                    <b-row>

                                        <b-col class="bg-dark" style="height: 43px">
                                            <span>
                                                {{ idx + 1 }}. Type:
                                                <b>{{
                                                    condition.condition_type
                                                }}</b>
                                            </span>
                                        </b-col>

                                        <b-col class="bg-dark" style="height: 43px">
                                            <span>
                                                Slot:
                                                <b>{{ condition.slot }}</b>
                                            </span>
                                        </b-col>

                                        <b-col class="bg-dark" style="height: 43px">
                                            <span v-if="condition.value">
                                                <b>
                                                    Value:
                                                    {{ condition.value }}</b>
                                            </span>
                                        </b-col>

                                        <b-col>
                                            <b-button @click="
                                                deleteCondition(
                                                    idx
                                                )
                                                ">Delete</b-button>
                                        </b-col>

                                    </b-row>
                                </li>
                            </ul>

                            <b-card-footer class="bg-dark">
                                <b-button @click="initAddCondition" variant="primary">Add
                                    Condition</b-button></b-card-footer>
                        </b-card>

                    </b-row>


                </div>

                <div v-if="toAdd">

                    <ConditionAdd :nonDefaultSlots="nonDefaultSlots" :addCondition="addCondition" :collapsed="collapsed"
                        :toAdd="toAdd" :cancelAddCondition="uninitAddCondition" :conditionAddedEvent="conditionAddedEvent"
                        :dataChangedEvent="dataChangedEvent"></ConditionAdd>
                </div>

                <div v-if="toAddHeader && !collapsed && !toAdd && !toAddParam">

                    <h4>Add Header</h4>
                    <b-form-group id="input-group-1" label="Slot:" label-for="input-1" description="Slot">
                        <b-form-select id="input-1" v-model="new_header.value" value-field="name" text-field="name"
                            :options="getAllSlots()" required></b-form-select>
                    </b-form-group>

                    <b-form-group id="input-group-3" label="Header Name:" label-for="input-3"
                        description="Your header name">
                        <b-form-input id="input-3" v-model="new_header.key" required></b-form-input>
                    </b-form-group>


                    <b-row>

                        <b-col>

                            <b-button :disabled="!new_header.value" @click="addHeader" variant="primary"
                                style="width: 100%">Save</b-button>

                        </b-col>

                        <b-col>
                            <b-button @click="toAddHeader = false" style="width: 100%" variant="danger">Cancel</b-button>
                        </b-col>

                    </b-row>


                </div>

                <div v-if="toAddParam && !collapsed && !toAdd && !toAddHeader">

                    <h4>Add Parameter</h4>
                    <b-form-group id="input-group-1" label="Slot:" label-for="input-1" description="Slot">
                        <b-form-select id="input-1" v-model="new_param.value" value-field="name" text-field="name"
                            :options="getAllSlots()" required></b-form-select>
                    </b-form-group>

                    <b-form-group id="input-group-3" label="Parameter Name:" label-for="input-3"
                        description="Your parameter name">
                        <b-form-input id="input-3" v-model="new_param.key" required></b-form-input>
                    </b-form-group>


                    <b-row>

                        <b-col>

                            <b-button :disabled="!new_param.value" @click="addParam" variant="primary"
                                style="width: 100%">Save</b-button>

                        </b-col>

                        <b-col>
                            <b-button @click="toAddParam = false" style="width: 100%" variant="danger">Cancel</b-button>
                        </b-col>

                    </b-row>



                </div>

                <div v-if="toAddConstant && !collapsed && !toAdd && !toAddHeader && !toAddParam">

                    <h4>Add Constant</h4>
                    <b-form-group id="input-group-1" label="Constant Name:" label-for="input-1"
                        description="Your constant name">
                        <b-form-input id="input-1" v-model="new_constant.key" required></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Constant Value:" label-for="input-2"
                        description="Your constant value">
                        <b-form-input id="input-2" v-model="new_constant.value" required></b-form-input>
                    </b-form-group>
                    <b-row>

                        <b-col>

                            <b-button :disabled="!new_constant.key || !new_constant.value" @click="addConstant"
                                variant="primary" style="width: 100%">Save</b-button>

                        </b-col>

                        <b-col>
                            <b-button @click="toAddConstant = false" style="width: 100%" variant="danger">Cancel</b-button>
                        </b-col>
                    </b-row>
                </div>



            </b-col>

        </b-row>

    </div>
</template>

<script>
import { del } from 'vue';
import ConditionAdd from './ConditionAdd.vue';


export default {
    name: 'ApiAction',
    components: {
        ConditionAdd
    },
    props: {
        actionData: {
            type: Object | String
        },
        conditionsData: {
            type: Array | Object
        },
        alternativesData: {
            type: Array | Object
        },
        valuesData: {
            type: Array | Object
        },
        actionidx: {
            type: Number
        },
        slotsData: {
            type: Array | Object
        },

        dataChangedEvent: {
            type: Function
        },
        languages: {
            type: Array | Object
        },
        headersData: {
            type: Object
        },
        paramsData: {
            type: Object
        },
        requestType: {
            type: String
        },
        constantsData: {
            type: Object
        },
        intentID: {
            type: String
        },

    },
    data() {
        return {
            collapsed: true,
            toAdd: false,
            toAddValue: false,
            new_header: {
                key: '',
                value: ''
            },
            toAddHeader: false,
            new_param: {
                key: '',
                value: ''
            },
            toAddParam: false,
            toAddConstant: false,
            requestTypes: [
                {
                    text: "GET",
                    value: "GET",
                },
                {
                    text: "POST",
                    value: "POST",
                }
            ],
            trueOrFalseOptions: [{
                    text: 'True',
                    value: true
                },
                {
                    text: 'False',
                    value: false
                }
            ],
            new_constant: {
                key: '',
                value: ''
            },
        }

    },
    methods: {
        initAddHeader() {
            this.toAddHeader = true;
            this.new_header = {
                key: '',
                value: ''
            }
        },
        initAddConstant() {
            this.toAddConstant = true;
            this.new_constant = {
                key: '',
                value: ''
            }
        },
        deleteHeader(key) {
            console.log('deleteHeader', key);
            delete this.headersData[key];
            console.log(Object.keys(this.headersData));

            //force re-render
            this.headersData = Object.assign({}, this.headersData);
            this.dataChangedEvent();
        },
        deleteConstant(key) {
            console.log('deleteConstant', key);
            delete this.constantsData[key];
            console.log(Object.keys(this.constantsData));

            //force re-render
            this.constantsData = Object.assign({}, this.constantsData);
            this.dataChangedEvent({
                'action_idx': this.actionidx,
                'intent_id': this.intentID,
                'event_type': 'delete_constant',
                'constant_key': key
            });
        },
        addHeader() {
            console.log('addHeader', this.new_header);
            this.headersData[this.new_header.key] = this.new_header.value;
            this.toAddHeader = false;
            this.headersData = Object.assign({}, this.headersData);
            this.dataChangedEvent();
        },
        addConstant() {
            console.log('addConstant', this.new_constant);
            if(this.constantsData == null) {
                console.log('constantsData is null, initializing');
                this.constantsData = {}; 
            }
            // this.constantsData = Object.assign({}, this.constantsData);
            this.constantsData[this.new_constant.key] = this.new_constant.value;
            console.log(this.constantsData);
            this.toAddConstant = false;
            this.constantsData = Object.assign({}, this.constantsData);
            this.dataChangedEvent({
                new_constant: this.new_constant,
                event_type: 'add_constant',
                'action_idx': this.actionidx,
                'intent_id': this.intentID
            });
        },
        initAddParam() {
            this.toAddParam = true;
            this.new_param = {
                key: '',
                value: ''
            }
        },
        deleteParam(key) {
            console.log('deleteParam', key);
            delete this.paramsData[key];
            console.log(Object.keys(this.paramsData));

            //force re-render
            this.paramsData = Object.assign({}, this.paramsData);
            this.dataChangedEvent();
        },
        addParam() {
            console.log('addParam', this.new_param);
            this.paramsData[this.new_param.key] = this.new_param.value;
            this.toAddParam = false;
            this.paramsData = Object.assign({}, this.paramsData);
            this.dataChangedEvent();
        },
        toggleViz() {
            this.collapsed = !this.collapsed;
        },
        addCondition(new_condition) {
            console.log('addCondition', new_condition);
            this.conditionsData.push(new_condition);
            this.toAdd = false;
            this.$emit('add-condition');

            this.dataChangedEvent();
        },
        initAddCondition() {
            this.toAdd = true;
            this.new_condition = {
                slot: '',
                condition_type: '',
                value: ''
            }
        },
        uninitAddCondition() {
            this.toAdd = false;
        },
        conditionAddedEvent() {
            this.toAdd = false;
            this.dataChangedEvent();
        },
        valueAddedEvent() {
            this.toAddValue = false;
            this.dataChangedEvent();
        },

        conditionDeletedEvent(idx) {
            this.conditionsData.splice(idx, 1);
            this.dataChangedEvent();
        },
        valueDeletedEvent(idx) {
            this.valuesData.splice(idx, 1);
            this.dataChangedEvent();
        },
        conditionDataChangedEvent() {
            this.dataChangedEvent();
        },
        valueDataChangedEvent() {
            this.dataChangedEvent();
        },
        stringTOId(str, actionidx) {
            return str + "-" + actionidx;
        },
        getNonDefaultSlots() {
            if (
                this.slotsData == null
            ) {
                return [];
            }

            return this.slotsData.filter(
                (slot) => slot.default !== true
            );
        },
        getAllSlots() {
            if (
                this.slotsData == null
            ) {
                return [];
            }

            return this.slotsData;
        },
        deleteCondition(idx) {
            console.log('deleteCondition', idx);
            this.conditionsData.splice(idx, 1);
            this.$emit('delete-condition', idx);

            this.dataChangedEvent();
        },
    },

    computed: {

        paramKeys() {
            if (
                this.paramsData == null
            ) {
                return [];
            }
            return Object.keys(this.paramsData);
        },

        constKeys() {
            if (
                this.constantsData == null
            ) {
                return [];
            }
            return Object.keys(this.constantsData);
        },

        headerKeys() {
            if (
                this.headersData == null
            ) {
                return [];
            }
            return Object.keys(this.headersData);
        },

        nonDefaultSlots() {
            if (
                this.slotsData == null
            ) {
                return [];
            }
            return this.slotsData.filter(
                (slot) => slot.default !== true
            );
        },
    },

    mounted() {
        console.log('mounted from ApiAction');
        // console.log(this.actionData);
        // console.log(this.slotsData);
    }
}

</script>